module.exports = __webpack_public_path__ + "asset/img/lemon.8c0d5ebbc77bacd90c624ce370a1b08e.svg";